
import { ListDataSource } from "@/data/List/ListDataSource";
import { Vue, Component, Prop } from "vue-property-decorator";
import ModeratorSelector from "./moderator-selector.vue";
import draggable from "vuedraggable";
import SessionProfessionalAreaSelector from "./session-professional-area-selector.vue";
@Component({
  components: { draggable, ModeratorSelector, SessionProfessionalAreaSelector },
})
export default class SessionItems extends Vue {
  @Prop() session!: any;
  @Prop() professionalAreaDataSource!: ListDataSource;
  @Prop() eventId!: number;
  @Prop() scheduleId!: number;
  @Prop() canEdit!: boolean;
  loaded: boolean = false;
  editMode: boolean = false;

  professionalAreaId: any = null;
  dataSource: ListDataSource = new ListDataSource({
    className: "EventSessionProfessionalArea",
    config: {},
  });
  items: any = [];
  $message: any;

  async created() {
    this.dataSource.items = this.session.eventSessionProfessionalAreas;
    this.loaded = true;
  }

  async add(professionalAreaId: number) {
    await this.dataSource.add(
      {
        eventId: +this.eventId,
        eventScheduleId: this.scheduleId,
        eventSessionId: this.session.id,
        professionalAreaId,
      },
      true,
    );
    this.professionalAreaId = null;
    this.editMode = false;
    this.$message("Успешно добавлено");
  }
}
